// Copyright (c) 2017 Deere & Company

import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import t from 'tcomb';

const DealerInvoiceFacets = t.struct({
    dealerAccountsFacet: DealerAccountsFacet
}, 'DealerInvoiceFacets');

export const getDefaultState = () =>
    new DealerInvoiceFacets({
        dealerAccountsFacet: getDealerAccountsFacetDefaultState()
    });

export default DealerInvoiceFacets;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/state/facets.js